import {
  type JobApplicationAck,
  type JobApplicationInput,
  type JobPosting,
} from '@resolute/schema';
import { useMutation, useQuery } from '@tanstack/react-query';


import { apiClient, getData } from '@/lib/api-client';

const careerKeys = {
  all: ['careers'] as const,
  jobs: () => [...careerKeys.all, 'jobs'] as const,
};

/** Active openings for the careers page. */
export function useJobPostings() {
  return useQuery({
    queryKey: careerKeys.jobs(),
    queryFn: () => getData<JobPosting[]>('/careers/jobs'),
    staleTime: 5 * 60 * 1000,
  });
}

/** Submit a candidate application (general or for a specific opening). */
export function useSubmitApplication() {
  return useMutation({
    mutationFn: async (input: JobApplicationInput) => {
      const res = await apiClient.post<{ data: JobApplicationAck }>('/careers/apply', input);
      return res.data.data;
    },
  });
}
